var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20515 6.99537C6.17722 7.01955 6.16497 7.05691 6.17516 7.09242C6.25272 7.36257 6.65283 8.54627 8.02944 9.92288C9.40606 11.2995 10.5898 11.6996 10.8599 11.7772C10.8954 11.7874 10.9328 11.7751 10.957 11.7472L11.7381 10.8447C11.8589 10.7051 12.0469 10.6434 12.2269 10.6843L15.4547 11.4175C15.91 11.5209 16.2331 11.9256 16.2332 12.3926L16.2334 14.4932C16.2335 15.5937 15.3393 16.4968 14.2534 16.3178C11.4196 15.8507 8.24857 14.3999 5.90048 12.0519C3.55333 9.7047 2.12348 6.55591 1.66381 3.73109C1.48705 2.64483 2.39048 1.75072 3.49103 1.75081L5.67914 1.751C6.15765 1.75104 6.56908 2.09006 6.6606 2.55974L7.27907 5.73371C7.31332 5.9095 7.25094 6.09019 7.11552 6.2074L6.20515 6.99537Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.0734f7e2be4201135963c6ae080d4fef.svg";